import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { CooperCrudService } from 'src/app/shared/services/cooper-crud.service';
import { Cooper } from 'src/app/shared/interfaces/cooper';


@Component({
  selector: 'app-coopers',
  templateUrl: './coopers.component.html',
  styleUrls: ['./coopers.component.scss']
})
export class CoopersComponent implements OnInit {

  coopers: Cooper[];
  cooper: Cooper;
  selectedCoopers: Cooper[] = [];

  cooperDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private cooperService : CooperCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Settings'},
      {label: 'Coopers'}
    ];

    this.coopers = [];
    this.cooper = { } as Cooper ;
  }

  ngOnInit(): void {

    this.isFilter = false;
    
    this.dataState();
    let s = this.cooperService.getList(); 
    s.snapshotChanges().subscribe(data => {
      this.coopers = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Cooper = jsonItem as Cooper;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.coopers.push(l);
        }
      })
    })

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'qrcode', header: 'QRCode' },
      { field: 'description', header: 'Description' },
      { field: 'tags', header: 'Tags' },
      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    // column that we shoa at the beginning
    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'qrcode');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');

    // Exports
   // this.exportColumns = this.cols.map(col => ( {title: col.header, dataKey: col.field} ) );
   // For the PDF 
   this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};
    } );
  }

  dataState() {     
    this.cooperService.getList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.coopers);
            doc.save('coopers.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.coopers);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "coopers");
    });
  }

  exportDTCSV() {
   // console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => 
      { exportCols.push(sc.field);
        // console.log('SAVEC CSV COL F ',sc.field);
        // console.log('SAVEC CSV COL ',sc);
      });
      exportCols.push('position');
      // console.log('SAVEC CSV SELECTED LOCATIONS ', this.selectedCoopers);
      // console.log('SAVEC CSV LOCATIONS ', this.coopers);
      // console.log('SAVEC CSV EXPORT COL ', exportCols);
      this.exportService.exportToCsv(this.selectedCoopers, 'coopers', exportCols);
   // this.exportService.exportToCsv(this.coopers, 'coopers', ['$key', 'name', 'description', 'tags', 'isEnabled', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.cooper = {} as Cooper;
    this.submitted = false;
    this.cooperDialog = true;
  }

  deleteSelectedCoopers() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected coopers?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.coopers = this.coopers.filter(val => !this.selectedCoopers.includes(val));
            this.selectedCoopers = [];
            this.selectedCoopers.forEach( cooper => this.cooperService.delete(cooper.$key));
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Cooperss Deleted', life: 3000});
        }
    });
  }

  editCooper(cooper: Cooper) {
    this.cooper = {...cooper};
    this.cooperDialog = true;
  }

  deleteCooper(cooper: Cooper) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + cooper.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.coopers = this.coopers.filter(val => val.$key !== cooper.$key);
            this.cooper = {} as Cooper;
            this.cooperService.delete(cooper.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Cooper Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.cooperDialog = false;
    this.submitted = false;
  }

  saveCooper() {
    this.submitted = true;

    if ( this.cooper.name.trim() ) {
      if (this.cooper.$key) {
          this.coopers[this.findIndexById(this.cooper.$key)] = this.cooper;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Cooper Updated', life: 3000});
          this.cooperService.update(this.cooper);
        } else {
          this.cooper.position = this.coopers.length;
          this.cooperService.add(this.cooper);
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Cooper Created', life: 3000});
      this.coopers = [...this.coopers];
    }

    this.cooperDialog = false;
    this.cooper = { } as Cooper;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.coopers.length; i++) {
        if (this.coopers[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeCooper(cooper : Cooper) {
    //console.log("SAVE", cooper);
    this.cooperService.update(cooper);
  }

  completePosition(cooper : Cooper) {
   // console.log("SAVE", cooper);
  //  this.cooperService.updateCooper(cooper);


    if ( this.newPosition > -1 ) {
        cooper.position = this.newPosition;
        cooper = this.checkPositionLimits(cooper);
        this.reorderElements(cooper);
        //this.updateDB(cooper);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    //console.log('Reorder event', event);
    // console.log('Before', this.coopers);
    // const myClonedArray = [];
    // this.coopers.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // console.log('Before2', myClonedArray);
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.coopers.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.coopers.length - 1 - event.dropIndex;
    const cooperToMove = this.coopers[startIndex];
    
    
    // console.log('StartIndex', startIndex);
    // console.log('EndIndex', endIndex);

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.coopers[index] = this.coopers[index+1];
        this.coopers[index].position = index;
        this.cooperService.update(this.coopers[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.coopers[index] = this.coopers[index-1];
        this.coopers[index].position = index;
        this.cooperService.update(this.coopers[index]);
      }
    } 
    this.coopers[endIndex] = cooperToMove;
    this.coopers[endIndex].position = endIndex;
    this.cooperService.update(this.coopers[endIndex]);
  }

  // onFieldEdit(cooper: Spray, fieldName: string): void {
  //   //console.log(this.coopers);
  //   console.log("Edit Init Event Called");
  //   console.log('Field name :'+fieldName);
  //   console.log('Field value :' + cooper[fieldName]);
  //   if (fieldName === 'position') {
  //     if ( this.newPosition ) {
  //       cooper.position = this.newPosition;
  //       cooper = this.checkPositionLimits(cooper);
  //       this.reorderElements(cooper);
  //       //this.updateDB(cooper);
  //       this.newPosition = undefined;
  //       this.previousPosition = undefined;
  //       return;
  //     }
      
  //   } else {
  //     this.updateDB(cooper);
  //   }
  // }


  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.coopers.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, cooper: Cooper) {
    // console.log("event" +event);
    if (cooper.position != null && cooper.position > -1) {
      this.previousPosition = cooper.position;
      this.newPosition = event;
    }
   
    // console.log("previous" +this.previousPosition);
    // console.log("new" +this.newPosition);
  }

  checkPositionLimits(cooper: Cooper) {
    console.log('check ',cooper.position + ' ' + this.coopers.length);
    if (!cooper.position) {
     // console.log('check 1');
      return this.cooper;
    }
    if (cooper.position < 0) {
      cooper.position = 0;
      // console.log('check 2');
      return cooper;
    }
    if (cooper.position > this.coopers.length) {
      cooper.position = this.coopers.length - 1;
    //  console.log('check 3', cooper.position);
      return cooper;
    }
   // console.log('check 4');
    return cooper;
  }

  async reorderElements(cooper: Cooper) {
    this.newPosition = this.newPosition  > this.coopers.length ? this.coopers.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === cooper.position ) {
      return;
    }
    // console.log('Previous position: '+ this.previousPosition);
    // console.log('New position: '+ this.newPosition);
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const cooperToMove = this.coopers[startIndex];
   // console.log('Item to move: ', this.coopers[startIndex]);
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        console.log('LOC', this.coopers);
        console.log('Item to +1: ', this.coopers[index+1]);

        this.coopers[index] = this.coopers[index+1];
        this.coopers[index].position = index;
        // console.log('Move: ', this.coopers[index+1]);
        // console.log('Move pos: ', this.coopers[index].position);
        //await this.updateDB(this.coopers[index]);
        this.cooperService.update(this.coopers[index]);
     //   console.log('Update DB: ', this.coopers[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.coopers[index] = this.coopers[index-1];
        this.coopers[index].position = index;
        this.cooperService.update(this.coopers[index]);
      }
    } 
    this.coopers[endIndex] = cooperToMove;
    this.coopers[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.cooperService.update(this.coopers[endIndex]);
    
    // const myClonedArray = [];
    // this.coopers.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // this.coopers = myClonedArray;
   // this.getAllRecords();
  }
}
